import { UseCases } from "@planzone/core";
import { Identifiable, Resource } from "@planzone/dto";
import { Context, Roles } from "../types";

function isOwnAllocation(resource: Identifiable<Resource>, context: Context) {
  return (
    !!context.allocation && context.allocation.resource.uuid === resource.uuid
  );
}

function updateFromAllocation(
  resource: Identifiable<Resource>,
  permissions: { [Key in UseCases]: Roles[] },
  context: Context,
): {
  [Key in UseCases]: Roles[];
} {
  return {
    ...permissions,
    [UseCases.editAllocation]: isOwnAllocation(resource, context)
      ? [...permissions.editAllocation, Roles.Worker]
      : permissions.editAllocation,
  };
}

export { updateFromAllocation };
